import moment from 'moment';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../../Echarts/Echarts';
import { arrayOfObjects } from '../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';
import { config } from '../../constant';
import {
  trendLabelTranslation,
  predictionsLegendsTranslation
} from '../../../Utils/Adapter/translationAdapter';

const Polar = (props) => {
  const getOption = (theme) => {
    return {
      angleAxis: {
        type: 'category',
        data: []
      },
      radiusAxis: {
        axisLabel: {
          fontSize: 18
        },
        z: 2
      },
      polar: {},
      series: [
        {
          type: 'bar',
          data: [],
          coordinateSystem: 'polar',
          name: ''
        }
      ],
      legend: {
        show: true,
        textStyle: {
          color: theme === 'lightTheme' ? 'black' : 'white',
          fontSize: 12,
          fontWeight: 'bold'
        },
        data: []
      }
    };
  };

  const [option, setOption] = useState(getOption(props.selectedThemeing));
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    selectedThemeing,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData(props, selectedThemeing);
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear
  ]);

  const getData = async (props, theme) => {
    requestCheck.current = false;
    let json = [];
    let { graphprops } = props;
    setErrorInAPI(false);
    setNoDataInDB(false);

    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = arrayOfObjects;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }

    if ((json && json.message) || (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      let Names = [];
      let legendsdata = [];
      let dates = [];
      let name = '';
      if (json && Array.isArray(json)) {
        json.forEach((val) => {
          if (val.Description && val.Description !== name) {
            if (Names.indexOf(val.Description) === -1) {
              Names.push(val.Description);
              name = val.Description;
              legendsdata.push({
                name: val.Description,
                textStyle: {
                  color: theme === 'lightTheme' ? 'black' : 'white',
                  fontSize: 16,
                  fontWeight: 'bold'
                }
              });
            }
          }
        });

        Names.forEach((tagval, tagindex) => {
          json.forEach((jsonval) => {
            if (Names[0] === jsonval.Description && tagindex === 0) {
              let date = {};
              if (props.graphprops.monthExists === 'true' || props.graphprops.monthExists === true) {
                date = props.graphprops.type === 'live'
                  ? moment.utc(jsonval.DateTime).tz(props.currentTimeZone).format('DD/MM/YYY')
                  : moment(jsonval.DateTime).tz(props.currentTimeZone).format('DD/MM/YYYY');
              } else {
                if (props.graphprops.polar && props.graphprops.polar.XAxisType && props.graphprops.polar.XAxisType === 'string') {
                  date = jsonval.DateTime;
                } else {
                  let format = props.graphprops.polar && props.graphprops.polar.xAxisDateFormat ? props.graphprops.polar.xAxisDateFormat : 'YYYY-MM-DD HH:mm:ss';

                  if (props.graphprops && props.graphprops.selection && props.graphprops.selection === 'dateMonthYearPicker') {
                    if (props.dayMonthYear && props.dayMonthYear.selectionType === 'day') {
                      date = props.graphprops.type === 'summary'
                        ? moment.utc(jsonval.DateTime).format('HH:mm')
                        : moment.utc(jsonval.DateTime).tz(props.currentTimeZone).format('HH:mm');
                    } else if (props.dayMonthYear && props.dayMonthYear.selectionType === 'month') {
                      date = props.graphprops.type === 'summary'
                        ? moment.utc(jsonval.DateTime).format('DD/MM')
                        : moment.utc(jsonval.DateTime).tz(props.currentTimeZone).format('DD/MM');
                    } else if (props.dayMonthYear && props.dayMonthYear.selectionType === 'year') {
                      date = props.graphprops.type === 'summary'
                        ? moment.utc(jsonval.DateTime).format('MMMM')
                        : moment.utc(jsonval.DateTime).tz(props.currentTimeZone).format('MMMM');
                    }
                  } else {
                    date = props.graphprops.type === 'summary'
                      ? moment.utc(jsonval.DateTime).format(format)
                      : moment.utc(jsonval.DateTime).tz(props.currentTimeZone).format(format);
                  }
                }
              }
              dates.push(date);
              return true;
            }
            return false;
          });
        });

        let valueName = json.map((val) => val.Description);
        let seriesArray = json.map((desc, index) => {
          return {
            name: valueName[index],
            type: 'bar',
            coordinateSystem: 'polar',
            stack: 'a',
            data: json.filter((e) => e.Description === desc.Description).map((barData) => barData.Value),
            emphasis: {
              focus: 'series'
            }
          };
        });

        let newOption = cloneDeep(option);
        let series = await trendLabelTranslation(seriesArray, props.translationCache);
        let legends = await predictionsLegendsTranslation(legendsdata, props.translationCache);
        if (props.graphprops && props.graphprops.polar && props.graphprops.polar.colors && props.graphprops.polar.colors.length > 0) {
          newOption.color = [...props.graphprops.polar.colors];
        }
        newOption.series = series;
        newOption.legend = [...legends];
        newOption.angleAxis.data = [...dates];
        setOption(newOption);
      }
    }
  };

  return (
    <Fragment>
      {noDataInDB || errorInAPI ? (
        noDataInDB ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <ReactEcharts
          option={option}
          style={{ height: '90%', width: '100%' }}
          className="react_for_echarts"
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    selectedThemeing: state.ThemeReducer.themeing
  };
};

export default connect(mapStateToProps)(Polar);